import React, { useState } from "react";
import SavedSearchTable from "../components/SavedSearch/SavedSearch";
import Container from 'react-bootstrap/Container';

const SavedSearch = () => {

    // const [selectdProject, setselectdProject] = useState(null)

    // const handleProjectChange = (entity) =>{
    //     console.log('PP selected '+entity.project_id)
    //     setselectdProject(entity.project_id)
    //     console.log('p ' + selectdProject)

    //   };
    //   const validate  = () =>{
    //     if (selectdProject == null)
    //         setErrorMessage("Please select a project folder");
    //   };
    return (
        <Container>
            <SavedSearchTable />
        </Container>
    );
};
export default SavedSearch;
